import styled from "styled-components";
import PropTypes from "prop-types";
import {
  desktopMarginVal,
  desktopMarginsCutoff,
  mobileMarginVal,
} from "../../styleConstants";

const ScrollArea = styled.div`
  // flex: 1 means this section stretches to fill gaps between header and footer.
  // overflow-y makes this the only scrollable section.
  // this styled div is separate from guts wrapper to keep scroll bar at panels rightmost edge, not awkardly at text's right edge in the middle of panel.
  flex: 1;
  overflow-y: auto;
`;

const GutsWrapper = styled.div`
  padding-left: ${mobileMarginVal}px;
  padding-right: ${mobileMarginVal}px;
  padding-top: 16px;
  padding-bottom: 16px;

  @media screen and (min-width: ${desktopMarginsCutoff}px) {
    padding-left: ${desktopMarginVal}px;
    padding-right: ${desktopMarginVal}px;
    padding-top: 16px;
    padding-bottom: 16px;
  }

  // just eye-balled what is a good page width.
  max-width: 680px;
  // max-width: 70ch;
`;

const SlideInContent = ({ contents }) => (
  <ScrollArea>
    <GutsWrapper>{contents}</GutsWrapper>
  </ScrollArea>
);

SlideInContent.propTypes = {
  contents: PropTypes.element,
};

export default SlideInContent;
